import sessionCookieMiddleware from '@/middleware/sessionCookie';
import rootReducer from '@/state/rootReducer';

import { configureStore } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import { middleware as flashMiddleware } from 'redux-flash';
import logger from 'redux-logger';

const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  filterBreadcrumbs: (breadcrumb) => {
    // Filter out specific breadcrumbs if needed
    return breadcrumb.category !== 'redux';
  },
  stateTransformer: (state) => {
    // Transform the state if needed
    const transformedState = { ...state, user: { ...state.user, session_token: 'sessionToken' } };
    return transformedState;
  }
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware().prepend(sessionCookieMiddleware.middleware),
    flashMiddleware(),
    logger
  ],
  enhancers: (getDefaultEnhancers) => [...getDefaultEnhancers(), sentryReduxEnhancer],
  devTools: process.env.NODE_ENV !== 'production'
});

export const setupStore = (preloadedState) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState
  });
};
